import React from "react";
import SocialLogin from "../SocialLogin";
import {Trans, useTranslation} from "react-i18next";
import {Field, reduxForm} from "redux-form";
import InputField from "../../forms/InputField";
import {email, required} from "./Validation";

function LoginForm({handleSubmit}) {
    const {t} = useTranslation();

    return <form onSubmit={handleSubmit}>
        <SocialLogin />
        <div className="row">
            <div className="column">
                <span className="label"><Trans>E-mail</Trans></span>
                <div className="text-holder">
                    <Field
                        name="email"
                        type="text"
                        component={InputField}
                        validate={[required, email]}
                        className="text"
                        placeholder={t('Enter your e-mail')}
                    />
                </div>
            </div>
            <div className="column">
                <span className="label"><Trans>Password</Trans></span>
                <div className="text-holder">
                    <Field
                        name="password"
                        type="password"
                        component={InputField}
                        validate={[required]}
                        className="text"
                        placeholder={t('Enter your password')}
                    />
                </div>
            </div>
        </div>
    </form>
}

LoginForm = reduxForm({
    form: 'LoginForm',
    enableReinitialize: true,
    destroyOnUnmount: true, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(LoginForm)

export default LoginForm